<template>
  <transition name="fade" mode="out-in">
    <div v-show="visible" class="confirm-box-wrapper">
      <div class="mask"></div>
      <div class="confirm-box">
        <h2 class="head">{{ title }}</h2>
        <div class="body" v-html="content">
          <!-- <p>1. 新增作者回复读者留言功能，在我的留 言里可以查看作者回复；</p>
          <p>2. 新增精品课程，优质内容仅需 1 元；</p>
          <p>3. 优化部分界面；</p>
          <p>4. 修复登录 bug。</p> -->
        </div>
        <div class="foot">
          <a v-if="btnCancel" @click="cancelHandler" class="btn-cancel">{{ btnCancel }}</a>
          <a v-if="btnOk" @click="okHandler" class="btn-primary">{{ btnOk }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      title: '',
      content: '',
      btnCancel: '',
      btnOk: '',
      closed: false,
      visible: false,
      cancelCallback: null,
      okCallback: null
    }
  },
  methods: {
    // cancelCallback () {
    //   this.$emit('cancel')
    // },
    // okCallback () {
    //   this.$emit('ok')
    // },
    destroyElement () {
      this.$el.removeEventListener('transitionend', this.destroyElement)
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    okHandler () {
      this.close()
      this.okCallback()
    },
    cancelHandler () {
      this.close()
      this.cancelCallback()
    },
    close () {
      this.closed = true
      // if (typeof this.onClose === 'function') {
      //   this.onClose(this)
      // }
    }
  },
  watch: {
    closed (val, oldVal) {
      if (val) {
        console.log('closed: ', val)
        this.visible = false
        this.$el.addEventListener('transitionend', this.destroyElement)
      }
    }
  }
}
</script>

<style lang="scss">
.confirm-box-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .confirm-box {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 267px;
    background: #fff;
    transform: translate(-50%, -50%);
    border-radius: 7px;
    .head {
      margin: 0 18px;
      font-size: 18px;
      text-align: center;
      line-height: 65px;
      border-bottom: #D9D9D9 solid 1px;
    }
    .body {
      padding: 18px;
      padding-bottom: 0;
      color: #353535;
      font-size: 12.5px;
      max-height: 150px;
      overflow: auto;
    }
    .foot {
      display: flex;
      flex-direction: row;
      padding: 18px;
      .btn-cancel {
        flex-grow: 1;
        height: 35px;
        display: inline-block;
        color: #888;
        font-size: 15px;
        text-align: center;
        line-height: 36px;
        border: #D9D9D9 solid 1px;
        border-radius: 3px;
        margin-right: 12px;
      }
      .btn-primary {
        flex-grow: 1;
        height: 35px;
        color: #FFF;
        display: inline-block;
        font-size: 15px;
        text-align: center;
        background-color: #D7B375;
        line-height: 36px;
        border-radius: 3px;
      }
    }
  }
}
</style>
